import Api from './api';

class ContactService {
  async saveContact(municipality, params) {

    const url = `/municipality/${municipality}/contact`;

    try {
      const res = await Api.post(url, params);
      return res;
    } catch (error) {
      return error;
    }
  }
}

export default new ContactService();



// WEBPACK FOOTER //
// ./src/api/contactService.js